// Vendor Components
import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const FormContext = React.createContext({
    formName: undefined,
    isFormValid: undefined,
    onSubmit: undefined,
    setFieldErrors: undefined,
    setFieldValue: undefined,
    unregisterFieldErrors: undefined,
    unregisterFieldValue: undefined,
});
